import * as React from 'react';
import { render } from 'react-dom';

import { IFooterSubscriptionProps } from './components/footer_subscription/footer_subscription';

import {
  clickOnHitLink,
  showHitLinks,
  trackChangeSkin,
} from './tracking';

import './legacy/filter_box.css';
import './legacy/footer.css';
import './legacy/similar.css';
import './legacy/similar_objects.css';

function loadComponents(): Promise<{[key: string]: React.ComponentClass<any>}> {
  return new Promise((resolve, reject) => {
    require.ensure([
      './components/footer_subscription/footer_subscription',
    ], () => {
      resolve({
        FooterSubscription: require('./components/footer_subscription/footer_subscription').default,
      });
    });
  });
}

export default function initSerp() {
  (window as any).renderOfferSerpFooter = (element: Element, props: IFooterSubscriptionProps) => {
    loadComponents()
      .then(({ FooterSubscription }) => {
        render(<FooterSubscription {...props} />, element);
      });
  };

  (window as any).trackSerpSkinChange = (newSkin: string, oldSkin: string) => {
    trackChangeSkin(newSkin, oldSkin);
  };

  (window as any).trackSerpClickOnHitLink = (pagination: boolean) => {
    clickOnHitLink(pagination);
  };

  (window as any).trackSerpShowHitLinks = (pagination: boolean) => {
    showHitLinks(pagination);
  };
}



// WEBPACK FOOTER //
// ./src/bundles/serp/index.tsx